import {Pipe, PipeTransform} from '@angular/core';
import {FundProductTypesEnum} from "@spa/api";

@Pipe({
	name: 'isMutualFunds',
	pure: false
})
export class IsMutualFundsPipe implements PipeTransform {
	transform(type: number): Boolean {
		return type === FundProductTypesEnum.MutualFund
	}
}
